import React from "react";
import { Loader2 } from "lucide-react";

// ------------------------------------------------------------
// Payment Loading Card
//
// Displayed while:
//
// • Waiting for gateway confirmation
// • Waiting for post-payment processing
// ------------------------------------------------------------

const PaymentLoadingCard: React.FC = () => {
  return (
    <div className="bg-white rounded-2xl border border-slate-200 shadow-3xs p-8 text-center">
      <Loader2 className="w-10 h-10 animate-spin text-logoHeading mx-auto mb-4" />

      <h2 className="text-lg font-black text-logoHeading">
        Processing Payment
      </h2>

      <p className="text-sm text-slate-500 mt-2">
        Please wait while we confirm your payment.
      </p>
    </div>
  );
};

export default PaymentLoadingCard;
